import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

export const NoAccount = () => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <>
      <div className="text-center">
        <h3>{t('auth.noaccount.title')}</h3>
        <div>{t('auth.noaccount.text.noAccountYet')}</div>
        <Link to={`/auth/register${location.search?.length ? location.search : ''}`}>
          <button className="btn" style={{marginTop: '15px'}}>
            {t('auth.noaccount.button.register')}
          </button>
        </Link>
      </div>
    </>
  )
}
